<template>
  <!--注册登陆弹出框-->
  <div class="module-mask" v-if="isVisible"></div>
  <div class="module-login" v-if="isVisible">
    <div class="logo">山东省心理咨询行业协会</div>
    <div class="title">手机号登录</div>
    <div class="input-area" @keyup.enter.down="keyDown">
      <div class="mod-tel border">
        <img src="/static/iconImg/icon-tel.png" alt="">
        <input type="text" v-model="phone" maxlength="11" placeholder="请输入手机号码">
      </div>
      <div class="mod-code">
        <div class="left border">
          <input type="text" v-model="code" placeholder="请输入动态验证码">
        </div>
        <div class="btn-send border" @click="sendVerifyCode">{{ count_down }}</div>
      </div>
      <div class="mod-captcha">
        <div class="left border">
          <input type="text" v-model="code_img" placeholder="请输入图形验证码">
        </div>
        <div class="captcha-img">
          <img @click="changeCodeImg" :src="codeUrl + '&id=' + codeId" alt="验证码图片" />
        </div>
      </div>
      <div class="btn-login this-mouse-pointer" @click="mobileLogin">登录/注册</div>
    </div>
    <!--关闭按钮-->
    <button class="btn-close this-mouse-pointer" id="J-login-close" type="button" @click="showLogin">×</button>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import user from "@/api/user";
import publics from "@/api/public";
import { verifyMobile } from "@/utils/validate";
import { uuid } from "@/utils/random";

defineProps({
  isVisible: Boolean
});

const store = useStore();

const second = ref(0);
const count_down = ref('获取验证码');
const phone = ref('');
const code = ref('');
const code_img = ref('');
const codeId = ref(uuid());
const codeUrl = ref('');
const timer = ref(null);

// 初始化图形验证码
const initCaptcha = () => {
  publics.captcha().then(res => {
    codeUrl.value = res;
    codeId.value = uuid();
  });
};

// 更新验证码图片
const changeCodeImg = () => {
  codeId.value = uuid();
};

// enter键提交
const keyDown = (e) => {
  if (e.keyCode == 13 || e.keyCode == 100) {
    mobileLogin();
  }
};

// 登录弹框
const showLogin = () => {
  store.dispatch('toggleLoginModal');
  phone.value = '';
  code.value = '';
  code_img.value = '';
  changeCodeImg();
  clearInterval(timer.value);
};

// 倒计时
const countDown = () => {
  timer.value = setInterval(() => {
    if (second.value > 0) {
      second.value = second.value - 1;
      count_down.value = second.value + 'S';
    } else {
      count_down.value = '获取验证码';
      clearInterval(timer.value);
    }
  }, 1000);
};

// 发送短信验证码
const sendVerifyCode = () => {
  if (second.value > 0) {
    ElMessage.error('请勿短时间内频繁操作！');
    return false;
  }
  if (!verifyMobile(phone.value)) {
    ElMessage.error('请输入正确格式的手机号！');
    return false;
  }
  // 倒计时，防误触
  second.value = 60;
  countDown();

  publics.sendSms({
    phone: phone.value
  }).then(res => {
    ElMessage.success(res.msg);
  });
};

// 手机号验证码登录
const mobileLogin = () => {
  if (!verifyMobile(phone.value)) {
    ElMessage.error('请输入正确格式的手机号！');
    return false;
  }
  if (!code.value) {
    ElMessage.error('请输入短信验证码！');
    return false;
  }
  if (!code_img.value) {
    ElMessage.error('请输入图形验证码！');
    return false;
  }
  user.userLoginOrReg({
    username: phone.value,
    code: code.value
  }).then(res => {
    store.dispatch('auth/login', {
      token: res.data.token,
      account: res.data.account,
      memberInfo: res.data.memberInfo
    });
    showLogin();
    location.reload();
  }).catch(() => {
    changeCodeImg();
  });
};

onMounted(() => {
  initCaptcha();
});

onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value);
  }
});
</script>
<style lang="scss" scoped>
.this-mouse-pointer {
  cursor: pointer;
}
.footer {text-align: center; font-size: 12px; color: #999; width: 100%;
  .copyright { padding: 20px; }
}

.mod-captcha {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;

  .left {
    flex: 1;
    
    input {
      width: 100%;
      height: 42px;
      padding: 0 15px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      font-size: 14px;
      outline: none;
      
      &:focus {
        border-color: #409eff;
      }
    }
  }

  .captcha-img {
    width: 120px;
    height: 42px;
    
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      object-fit: cover;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.module-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.58);
}

.module-login {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 2001;
  width: min(520px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  margin: 0;
  padding: 34px 56px 42px;
  overflow-y: auto;
  box-sizing: border-box;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 22px 70px rgba(18, 42, 66, 0.28);
  transform: translate(-50%, -50%);

  .logo {
    margin-bottom: 12px;
    color: #1f2d3d;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.35;
    text-align: center;
    letter-spacing: 1px;
  }

  .title {
    margin-bottom: 28px;
    color: #111;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    text-align: center;
    letter-spacing: 1px;
  }

  .input-area {
    .border {
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus-within {
        border-color: #1e9dd4;
        box-shadow: 0 0 0 3px rgba(30, 157, 212, 0.12);
      }
    }

    input {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      color: #303133;
      font-size: 16px;
      line-height: 1;
      background: transparent;
      border: 0;
      outline: none;

      &::placeholder {
        color: #8a8f99;
      }
    }

    .mod-tel {
      display: flex;
      align-items: center;
      height: 52px;
      margin-bottom: 16px;
      padding: 0 16px;
      box-sizing: border-box;

      img {
        width: 14px;
        margin-right: 14px;
      }
    }

    .mod-code,
    .mod-captcha {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 128px;
      gap: 12px;
      height: auto;
      margin-bottom: 16px;

      .left,
      .btn-send,
      .captcha-img {
        height: 52px;
        box-sizing: border-box;
      }

      .left {
        width: auto;
        padding: 0 16px;
      }
    }

    .mod-code {
      align-items: stretch;
      justify-content: initial;

      .btn-send {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        line-height: normal;
        color: #1e9dd4;
        font-size: 15px;
        background: #f7fbfd;

        &:hover {
          color: #1789bd;
          border-color: #1e9dd4;
        }
      }
    }

    .mod-captcha {
      align-items: stretch;

      .captcha-img {
        width: auto;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }
    }

    .btn-login {
      width: 100%;
      height: 52px;
      margin-top: 8px;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      line-height: 52px;
      text-align: center;
      background: #1e9dd4;
      border-radius: 6px;
      transition: background 0.2s, transform 0.2s;

      &:hover {
        background: #1789bd;
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }

  .btn-close {
    position: absolute;
    top: 14px;
    right: 16px;
    width: 32px;
    height: 32px;
    padding: 0;
    color: #909399;
    font-size: 26px;
    line-height: 30px;
    text-align: center;
    background: transparent;
    border: 0;
    border-radius: 50%;

    &:hover {
      color: #1e9dd4;
      background: #f2f6f9;
    }
  }
}

@media (max-width: 640px) {
  .module-login {
    width: calc(100vw - 24px);
    padding: 30px 20px 28px;
    border-radius: 12px;

    .logo {
      font-size: 20px;
    }

    .title {
      margin-bottom: 22px;
      font-size: 18px;
    }

    .input-area {
      .mod-code,
      .mod-captcha {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
